/**
 * Calm reliability signal: a coloured dot + word. Green "Reliable", amber
 * "Building reputation", and *nothing* for low scores — never a hostile "low"
 * badge on cards (autonomy pillar: not punitive). The exact number is shown
 * only on profiles, not here.
 */
import { reliabilityLevel } from '@waylo/shared';
import { useT } from '../lib/i18n';

export function ReliabilityBadge({
  score,
  ridesCompleted,
}: {
  score: number;
  ridesCompleted: number;
}): JSX.Element | null {
  const { t } = useT();
  const level = reliabilityLevel({ score, ridesCompleted });
  if (level === 'low') return null;
  const dot = level === 'reliable' ? 'bg-brand-green' : 'bg-[var(--warning)]';
  const label = level === 'reliable' ? t('reliability.reliable') : t('reliability.building');
  return (
    <span className="inline-flex items-center gap-1 text-xs text-tg-hint">
      <span className={`inline-block h-2 w-2 flex-none rounded-full ${dot}`} aria-hidden />
      {label}
    </span>
  );
}
